// extracted by mini-css-extract-plugin
module.exports = {"share":"share__share___3PNDJ","title":"share__title___g0B18 _type__vx_text-5___2iJ3U"};